import LoginBanner from "components/shared/LoginBanner";
import Button from "components/ui/Button";
import React from "react";
import { Link } from "react-router-dom";

const VerifiedEmailLink = () => {
  return (
    <div className="grid grid-cols-1 bg-[#F2F2F2]  md:grid-cols-2">
      <div className="flex flex-wrap flex-col justify-center px-1  h-svh md:px-32">
        <div className="text-3xl font-bold">
          Verification link has
          <br />
          expired
        </div>
        <div className="mt-3 text-sm font-normal text-lightGrey">
          The link expires after 7 days,but we can send another
          <br />
          verification link on abc@gmail,.com
        </div>

        <div className="mt-3 text-sm font-normal text-lightGrey">
          Please login on GBX\login to request a new verification link.
        </div>

        <div className="mt-6">
          <Button title="Resend Mail" />
        </div>

        <div className="mt-3 flex  text-xs font-semibold gap-1">
          <div className="text-lightGrey">Need Help?</div>
          <Link to="/visit-support" className="text-secondary">
            Visit Support
          </Link>
        </div>
      </div>
      <LoginBanner />
    </div>
  );
};

export default VerifiedEmailLink;
